export const ItemTypes = {
  CARD: 'card',
  SUB: 'sub',
}
